import { Injectable } from '@angular/core';
import {ApiService} from './http/api.service';
import { Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SaleOrderService {

  reload = new Subject();

  constructor(private apiClient: ApiService) { }

  getReasonCode(companyId: number): any {
    return this.apiClient.get(`/${companyId}/sales-orders/reasons`);
  }

  getSaleOrders(companyId: number): any {
    return this.apiClient.get(`/${companyId}/sales-orders`);
  }

  getSaleOrderList(companyId: number, pageSize : number, pageNumber : number, productGroupId : number, search : string, sort : string): any {
    return this.apiClient.get(`/${companyId}/sales-orders/all?pageSize=${pageSize}&pageNumber=${pageNumber}&pageNumber=${pageNumber}&productGroupId=${productGroupId}&search=${search}&sort=${sort}&companyId=${companyId}`);
  }

  getSaleOrdersForApprove(companyId: number): any {
    return this.apiClient.get(`/${companyId}/sales-orders/approve-list`);
  }

  getSaleOrder(companyId: number, saleRegisterId: number): any {
    return this.apiClient.get(`/${companyId}/sales-orders/${saleRegisterId}`);
  }

  getSalesOrderByBranchReport(companyId: number, year: number, month: number): any {
    return this.apiClient.get(`/${companyId}/sales-order-report/salesorderbybranchreport/${year}/${month}`);
  }

  getSalesOrderBySalesPlanReport(companyId: number, year: number, month: number): any {
    return this.apiClient.get(`/${companyId}/sales-order-report/salesorderbysalesplanreport/${year}/${month}`);
  }

  getSalesOrderByDateReport(companyId: number, year: number, month: number): any {
    return this.apiClient.get(`/${companyId}/sales-order-report/salesorderbydatereport/${year}/${month}`);
  }

  createSaleOrder(companyId: number, data: any): any {
    return this.apiClient.post(`/${companyId}/sales-orders`, data);
  }

  updateSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}`, data);
  }

  approveSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}/approve`, data);
  }

  approveWithConditionSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}/approve-condition`, data);
  }

  saveDocument(companyId: number, salesorder: number, data: any) {
    return this.apiClient.put(`/${companyId}/sales-orders/document/${salesorder}`, data);
  }

  submitSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}/submit`, data);
  }

  sendBackSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}/send-back`, data);
  }

  saveSendBackSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}/save-send-back`, data);
  }

  cancelSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}/cancel`, data);
  }

  sendToSAPSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}/send-to-sap`, data);
  }

  rejectSaleOrder(companyId: number, saleRegisterId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/sales-orders/${saleRegisterId}/reject`, data);
  }

  verifyCustomer(citizenId: string): Observable<any> {
    return this.apiClient.get(`/customer/${citizenId}`);
  }

  receiveJob(data: any): any {
    return this.apiClient.put(`/notification/receive-job`, data);
  }

  unlockJob(data: any): any {
    return this.apiClient.put(`/notification/unlock-job`, data);
  }

  changeStatus(companyId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/service/sales-order/change-status`, data);
  }

  getNations(): any {
    // getListCache
    return this.apiClient.getListCache(`/get-nations`);
  }

  getOccupations(): any {
    return this.apiClient.getListCache(`/get-occupations`);
  }

  checkVerify(companyId: number, citizenId: string): Observable<any> {
    return this.apiClient.get(`/${companyId}/salesperson/validate/${citizenId}`);
  }

  getBank(companyId: number, type: string): Observable<any> {
    return this.apiClient.get(`/${companyId}/lookups/${type}/list`);
  }

  createContract(companyId: number, saleOrderId: number): any {
    const url = environment.serverUrl.replace('/v1', '/api/v1');
     return this.apiClient.post(`${url}/salesorder/${saleOrderId}/contract`,null);
  }

  getByGroupType(companyId, productGroupId, productTypeId): Observable<any>{
    return this.apiClient.get(`/${companyId}/products/get-by-group-type/${productGroupId}/${productTypeId}`);
  }

  getIsConsent(companyId: number, type: string): Observable<any> {
    return this.apiClient.get(`/${companyId}/lookups/${type}/list`);
  }

  checkSaleStructureTeams(companyId : number, branchId : number, citizenId : string){

    return this.apiClient.get(`/${companyId}/sales-structure-teams/check-sales-structure-teams/${branchId}/${citizenId}`);
  }

  resendContractEmail(companyId : number, saleOrderId: number | string) {
    return this.apiClient.post(`/${companyId}/sales-orders/${saleOrderId}/resend-email-contract`, {});
  }

  activateKiosk(companyId: number | string, id: number | string) {
    return this.apiClient.post(`/${companyId}/sales-orders/${id}/kiosk-activated`, {});
  }

  checkProductLimit(companyId: number | string, productGroupId: number | string, citizenId: number | string) {
    return this.apiClient.get(`/${companyId}/sales-orders/check-orders-limit/${productGroupId}/${citizenId}`);
  }

}
